<template>
  <div v-if="job !== undefined">
    <li class="list-group-item px-0">
        <div class="row align-items-center">
            <!-- TODO: job thumb here? -->
            <!-- <div class="col-auto" v-if="item.image">
                <b-img :src="item.image" rounded alt="Rounded image"></b-img>
            </div> -->
            <div class="col">
                <div class="d-flex justify-content-between">
                    <h5 class="mb-1">{{job.name}}</h5>
                    <small class="text-muted">{{snapshot.copyState.progress | jobProgress}}</small>
                </div>
                <div>
                    <b-progress :max="job.bytes" class="my-2">
                        <!-- <b-progress-bar variant="success" :value="25" show-progress></b-progress-bar> -->
                        <b-progress-bar variant="primary" :value="bytesVerified"></b-progress-bar>
                        <b-progress-bar variant="primary" :value="bytesCopied" animated></b-progress-bar>
                    </b-progress>
                </div>
                <div class="d-flex justify-content-between">
                    <small class="text-muted">{{$moment(snapshot.snapTimestamp).calendar()}}</small>
                    <small class="text-muted">{{snapshot.copyState.standing | jobStanding}}</small>
                </div>
            </div>
        </div>
    </li>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    jobId: {
      type: String,
      required: true,
    },
  },
  created() {
    // console.log('CREATED JOB LIVE ITEM', this.jobId, this.snapshot, this.job);
  },
  computed: {
    ...mapGetters('live', [
      'snapshotById',
    ]),
    ...mapGetters('jobs', [
      'jobById',
    ]),
    snapshot() {
      return this.snapshotById(this.jobId);
    },
    job() {
      return this.jobById(this.jobId).toObject(); // TODO: this is like the only thing in the app that hasn't been toObjected... fuckin fix.
    },
    bytesCopied() {
      // math to make the verified bar overlap the copied bar. subtract the amount of copied bytes that will be covered by verified bytes
      return this.snapshot.copyState.bytesCopied - this.snapshot.copyState.bytesVerified;
    },
    bytesVerified() {
      return this.snapshot.copyState.bytesVerified;
    },
  },
};
</script>
